import React from 'react';
import { number } from '../../../Common/Util/number';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const TableRegistersHoseHoldByHealthUnit = () => {
    const { chartData } = useMappingChartsDataContext();

    const columns = [
        {
            key: 'description',
            header: 'Unidade de Saúde',
            headerStyle: {
                width: '60%',
                fontWeight: '500'
            },
            cellStyle: {}
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: {
                width: '40%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                data={chartData?.registersHoseHoldByHealthUnit ?? []}
                columns={columns}
                title="Totais"
                showTotal={true}
                maxHeight="400px"
                className="w-100"
                totalColumn="total"
            />
        </div>
    );
};
